import http from '../utils/request.js'

const getUserInfo = (data) => {
    return http.get('/userinfo',data)
}
const logout = (data) => {
    return http.post('/logout', data)
}
const checkLogin = () => {
    return http.post('/checklogin')
}
const login = (data) => {
    return http.post('/login', data)
}
const verifyToken = ( data ) => {
    return http.post('/verifytoken', data )
}
const getInviteCode = () => {
    return http.post('/invitecode', {})
}

export {
    getUserInfo,
    logout,
    checkLogin,
    login,
    verifyToken,
    getInviteCode
}